import * as React from 'react'

export const ResizeContext = React.createContext({})

interface MultiSliderProps {
  children: React.ReactNode
}

export const MultiSlider: React.FC<MultiSliderProps> = ({ children }) => {
  const [resize, setResize] = React.useState(false)
  return (
    <ResizeContext.Provider value={{ resize, setResize }}>
      {children}
    </ResizeContext.Provider>
  )
}
